import React from "react";
import ReactDOM from "react-dom/client";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";
import "./i18n/i18n";
import axios from "axios";
import {
  setupGlobalAxiosInterceptor,
  setupOfflineRequestListener,
} from "./shared/utils.js/offlineRequestManager";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { prewarmOfflineCache } from "./shared/utils.js/offlinePrefetcher";

setupGlobalAxiosInterceptor(axios);
setupOfflineRequestListener();

serviceWorkerRegistration.register();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
